import * as React from 'react'
import { Box, Typography, Link, Badge } from '@mui/material';
import { TooltipSeeker } from "@ui-seeker/core";
import {formatPriceSymbol} from "@ui-seeker/utils";

import {useUserApp, useBuildExternalURL} from "@hooks";
import {BadgeVariant} from "@components";

export default function minRetailerPriceColumn(name, label) {
	return {
		name: name, label: label,
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: (value, row) => <MinRetailerPriceCell value={value} {...row} />
		}
	}
}

const MinRetailerPriceCell = ({ value, currency, minRetailer, minIdSite, minProductId, minPriceStock, date, minSiteNumVariants}) => {
	const { userGroupByProductID } = useUserApp()
	const { productURL } = useBuildExternalURL({ siteData: { siteID: minIdSite, productID: minProductId } })
	return <Box>
		<Box sx={{ display: 'flex', alignItems: 'center'}}>
			<Typography>{formatPriceSymbol(value, currency)}</Typography>
			<TooltipSeeker title={minPriceStock ? 'In Stock' : 'Out of Stock'} >
				<Badge
					color={minPriceStock ? 'success' : 'error'}
					badgeContent=""
					sx={{ ml: 2, mr: 1 }}
				/>
			</TooltipSeeker>
			{!userGroupByProductID && !!minPriceStock && <BadgeVariant numVariants={minSiteNumVariants} />}
		</Box>
		{ minRetailer && <Typography variant="caption" sx={{ fontStyle: 'italic', pr: 1, fontSize: 11 }}>
			{ productURL ? <Link href={productURL} target="_blank">
				{minRetailer}
			</Link> : minRetailer }
		</Typography> }
	</Box>
}